<template>
    <div class="profile bg-white pb-5">
        <div class="p-md-4">
            <div class="profile">
                <div class="d-flex justify-content-between">
                    <h5 class="mb-0">
                        <span class=" text-capitalize" v-if="profileData.Username">{{
                            profileData.Username + `'s`
                        }}</span>
                        Profiles
                    </h5>
                    <div v-if="profileData.portfolioLink">
                        <a-tooltip placement="topLeft">
                            <template slot="title">
                                <span
                                    ><a-icon
                                        type="info-circle"
                                        style="position:relative; bottom: 3px;font-size: 16px;"
                                    />
                                    {{ copied ? 'Copied to clipboard' : 'Click to copy' }}</span
                                >
                            </template>
                            <span
                                @mouseover="copied = false"
                                @click="copy(profileData.portfolioLink)"
                                class="kova-id px-3 py-1 text-white font-weight-bolder"
                                >{{ profileData.portfolioLink }}</span
                            >
                        </a-tooltip>
                    </div>
                </div>
                <hr />
                <div class="text-left" v-if="!loading">
                    <h6>{{ profileData.profileTitle }}</h6>
                    <div style="line-height: 2">
                        {{ profileData.AboutMe }}
                    </div>
                    <div :key="i" v-for="(skill, i) in profileData.Skills || []" class="mb-4 font-weight-bolder">
                        <!-- v-for="(skills, i) in generalSkills" -->
                        <p>* {{ skills.name }} {{ skills.level }}</p>
                        <p>- {{ skills.frameworks }}</p>
                    </div>
                </div>
                <a-skeleton active v-else />

                <div>
                    <!-- <h6 class="text-left font-weight-bold">I am problem solving, eager to learn new things if needed, Does Something works for you? Let's get in touch.</h6> -->
                </div>
            </div>
            <hr />
        </div>

        <div class="mt-4 mt-md-0">
            <div class="p-4">
                <h5>Skills</h5>
            </div>
            <div class="py-4 px-2 px-md-4 border shadow-sm bg-light" v-if="!loading">
                <div class="text-left d-flex flex-wrap" v-if="profileData.skillSet.length">
                    <span
                        class="bg-skills px-3 py-2 ml-3 mb-3 rounded text-size4"
                        v-for="skill in profileData.skillSet"
                        :key="skill"
                    >
                        {{ skill }}</span
                    >
                </div>
                <div class="text-center" v-else>
                    You have no skills
                </div>
            </div>
            <a-skeleton active v-else />
        </div>

        <div class="my-4">
            <div class="p-4">
                <h5>Portfolio</h5>
            </div>
            <div v-if="!loading" class="py-4 px-2 px-md-4 bg-light border shadow-sm">
                <div class="row px-4" v-if="projects.length">
                    <div
                        class="col-sm-12 col-md-4 my-3 bg-white border add-h portfolio-link"
                        :key="i"
                        v-for="(link, i) in projects"
                        @click="
                            siteLink = formatLink(link);
                            showEmbed = true;
                        "
                    >
                        <img class="favicon mt-3" :src="getFavicon(formatLink(link))" />
                        <h1 class="my-1">
                            {{
                                formatLink(link)
                                    .slice(0, 2)
                                    .toUpperCase()
                            }}
                        </h1>
                        <p>{{ link }}</p>
                    </div>
                </div>
                <div class="px-4 text-center" v-else>
                    You have no portfolio
                </div>
            </div>

            <a-skeleton active v-else />

            <view-link
                :key="viewKey"
                :link="siteLink"
                :visible="showEmbed"
                @close="
                    showEmbed = false;
                    viewKey++;
                "
            ></view-link>
        </div>

        <div class="mt-4" v-if="!loading">
            <div class="p-4">
                <h5>Work History and Feedback</h5>
            </div>
            <div class="py-4 px-2 px-md-4  bg-light border shadow-sm rounded" v-if="workHistory.length">
                <div :key="i" v-for="(work, i) in workHistory">
                    <div class="row">
                        <div class="col-md-9 text-left">
                            <h6 class="font-weight-bolder kova-text">{{ work.title }}</h6>
                            <span>
                                <!-- <span :key="n" v-for="n in work.star"><font-awesome-icon icon="star" size=""></font-awesome-icon></span> <b>{{work.star}}.00</b>  -->
                                <span class="font-weight-light text-size4">{{ work.duration }}</span>
                            </span>
                            <p class="text-size3">{{ work.comment }}</p>
                        </div>
                        <!-- <div class="col-md-3">

                    </div> -->
                        <div class="col-md-3 text-right float-text">
                            <h6 class="font-weight-bolder kova-text">${{ work.earned }}</h6>
                            <h6>${{ work.earnedPerHour }}.00 / hr</h6>
                            <!-- <h6>{{work.hours}} hours </h6> -->
                            <span
                                ><img class="mr-2" src="../assets/kovatek/best.svg" alt="" /><span
                                    class="font-weight-bolder"
                                    >9.5</span
                                ></span
                            >
                        </div>
                    </div>
                    <hr />
                </div>
            </div>
            <div class="p-4 bg-light border shadow-sm rounded text-center" v-else>
                You have no work history yet
            </div>
        </div>

        <div class="mt-4" v-else>
            <div class="p-4">
                <h5>Work History and Feedback</h5>
            </div>
            <a-skeleton active />
        </div>
    </div>
</template>

<script>
import ViewLink from './ViewLink.vue';

export default {
    name: 'profile',
    components: {
        ViewLink,
    },
    computed: {
        projects() {
            const {
                OtherCoreTechstackProjects,
                ProjectsCompletedLinks,
                ProjectsLed,
                RemoteProjectLinks,
            } = this.profileData;
            const projects = [
                ...(OtherCoreTechstackProjects || []),
                ...(ProjectsCompletedLinks || []),
                ...(ProjectsLed || []),
                ...(RemoteProjectLinks || []),
            ];
            return [...new Set(projects)];
        },
    },
    props: {
        profileData: Object,
        loading: Boolean,
    },
    data() {
        return {
            siteLink: '',
            viewKey: 43,
            showEmbed: false,
            workHistory: [
                // {
                //   title: 'PHP / extJS / MVC Application Update',
                //   duration: ' Mar 2016 - Sep 2018',
                //   star: 5,
                //   comment: 'Solid experience with PHP and extJS. Good quality work.',
                //   earned: 963.34,
                //   earnedPerHour: 20.0,
                //   hours: 48,
                // },
                // {
                //   title: 'ExtJS prototype development',
                //   duration: 'Jul 2016 - Aug 2016',
                //   star: 5,
                //   comment: 'Nice job, completed on-time and high quality.',
                //   earned: 560.0,
                //   earnedPerHour: 30.0,
                //   hours: 19,
                // },
                // {
                //   title: 'PHP / extJS / MVC Application Update',
                //   duration: ' Mar 2016 - Sep 2018',
                //   star: 5,
                //   comment: 'Solid experience with PHP and extJS. Good quality work.',
                //   earned: 963.34,
                //   earnedPerHour: 20.0,
                //   hours: 48,
                // },
                // {
                //   title: 'ExtJS prototype development',
                //   duration: 'Jul 2016 - Aug 2016',
                //   star: 5,
                //   comment: 'Nice job, completed on-time and high quality.',
                //   earned: 560.0,
                //   earnedPerHour: 30.0,
                //   hours: 19,
                // },
                // {
                //   title: 'PHP / extJS / MVC Application Update',
                //   duration: ' Mar 2016 - Sep 2018',
                //   star: 5,
                //   comment: 'Solid experience with PHP and extJS. Good quality work.',
                //   earned: 963.34,
                //   earnedPerHour: 20.0,
                //   hours: 48,
                // },
                // {
                //   title: 'ExtJS prototype development',
                //   duration: 'Jul 2016 - Aug 2016',
                //   star: 5,
                //   comment: 'Nice job, completed on-time and high quality.',
                //   earned: 560.0,
                //   earnedPerHour: 30.0,
                //   hours: 19,
                // },
            ],
        };
    },
    methods: {
        formatLink: link =>
            link
                .replace(/www./g, '')
                .replace(/http:\/\//g, '')
                .replace(/https:\/\//g, ''),
        getFavicon(link) {
            const text = link.replace(/www./g, '');
            return `http://www.google.com/s2/favicons?domain=www.${text}`;
        },
    },
};
</script>

<style scoped>
img.favicon {
    /* position: absolute; */
    height: 25px;
    width: 25px;
}

.profile h5 {
    font-size: 20px;
}

.profile h6 {
    font-size: 16px;
}

.kova-text {
    color: #20409a;
}
.text-size1 {
    font-size: 20px;
}
.text-size2 {
    font-size: 18px;
}
.text-size3 {
    font-size: 16px;
}
.text-size4 {
    font-size: 12px;
}
.text-size5 {
    font-size: 10px;
}
.cont-progress-height {
    height: 6px;
}
.user-check-col {
    color: #41cbf6;
}
.adjust-p-size {
    font-size: 24px;
}

.text-senior {
    color: #bd6377;
}
.text-intermediate {
    color: #bdbd50;
}

.img-height {
    height: 150px;
    width: 150px;
}
.add-h {
    height: 150px;
}
.bg-skills {
    background-color: #4bb38e;
    color: #fff;
}

.portfolio-link:hover {
    background-color: #20409a !important;
    border-radius: 5px;
    cursor: pointer;
    transform: scale(1.15);
    z-index: 9;
}

.portfolio-link:hover h1,
.portfolio-link:hover p {
    color: #ffffff !important;
}

@media screen and (min-width: 992px) and (max-width: 1325px) {
    .img-height {
        height: 100px;
        width: 100px;
    }
}

@media screen and (min-width: 768px) and (max-width: 991px) {
    .img-height {
        height: 150px;
        width: 150px;
    }
}

@media screen and (max-width: 767px) {
    .img-height {
        height: 100px;
        width: 100px;
    }
    .float-text {
        display: flex;
        justify-content: space-between;
        padding-right: 50px;
    }
    .float-text h6 {
        float: left;
        /* margin-right: 40px; */
    }
}
/* 
@media screen and (max-width: 550px){
    
} */
</style>
